import PropTypes from 'prop-types';
import { memo } from 'react';
import clsx from 'clsx';

const MaxBadges = 3;

const TourBadges = ({ itinerary, className }) => {
  const tour = itinerary.tour || {};
  const policy = itinerary.cancellationPolicy || '';
  const percentNoRefund = tour.percentNoRefund;
  const isNonRefundable = percentNoRefund >= 100 || /non-?refundable|no refund/i.test(policy);
  const isPartlyRefundable = !isNonRefundable && percentNoRefund > 0;
  const isFreeCancellation =
    !isNonRefundable && !isPartlyRefundable && /^free cancellation/i.test(policy);

  const badges = [
    tour.isOnlyQuotable && { label: 'Quote only', tone: 'warn' },
    tour.confirmationType === 'Automatic' && { label: 'Instant confirmation', tone: 'good' },
    isNonRefundable && { label: 'Non-refundable', tone: 'warn' },
    isPartlyRefundable && { label: `${percentNoRefund}% non-refundable`, tone: 'warn' },
    isFreeCancellation && { label: 'Free cancellation', tone: 'good' },
    tour.isDepositOnly && { label: 'Deposit now', tone: 'info' },
    tour.hotelPickupOffered && { label: 'Hotel pick-up', tone: 'info' },
    tour.isShoreExcursion && { label: 'Shore excursion', tone: 'info' },
  ]
    .filter(Boolean)
    .slice(0, MaxBadges);

  if (!badges.length) {
    return <span />;
  }

  return (
    <div className={clsx('flex', className)}>
      {badges.map((badge) => (
        <span
          key={badge.label}
          className={clsx('text-xs px-2 py-px rounded mr-2 whitespace-no-wrap', {
            'bg-green-100 text-green-800': badge.tone === 'good',
            'bg-yellow-100 text-yellow-800': badge.tone === 'warn',
            'bg-gray-100 text-gray-700': badge.tone === 'info',
          })}
        >
          {badge.label}
        </span>
      ))}
    </div>
  );
};

TourBadges.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

TourBadges.defaultProps = {
  className: '',
};

export default memo(TourBadges);
